import axios from "@/lib/axios";
import { DimensionId, Question } from "@/types/questionnaries";

export type GetResponsesByQuizIdRequestParams = {
  companyId: string;
  quizId: string;
  dimension?: DimensionId;
  topic?: string;
};

export type GetResponsesByQuizIdItemResource = {
  id: string;
  type: string;
  name: string;
  reference: string;
  comment: string;
};

export type GetResponsesByQuizIdItemEvidence = {
  id: string;
  resources: GetResponsesByQuizIdItemResource[];
};

export type EvaluationCriteriaType = {
  criteriaType: string;
  name: string;
  description: string;
};

export type EvaluationCriteria = {
  id: string;
  criteriaType: EvaluationCriteriaType;
  scoreProportion: number;
};

export type ResponseType = {
  name: string;
  responseType: "AFFIRMATIVE" | "NEGATIVE" | "NOT_APPLICABLE";
};

export type CriteriaScore = {
  criteriaId: string;
  score: number;
  scoreProportion: number;
};

export type Feedback = {
  benchmarkAndReferences: string | null;
  bestPractices: { bestPractices: string; addInReport: boolean };
  recommendations: { recommendations: string; addInReport: boolean };
  tools: string | null;
};

export type GetResponsesByQuizIdItem = Question & {
  responseId: string;
  questionId: string;
  evidences: GetResponsesByQuizIdItemEvidence[];
  additionalComments?: string;
  allowAdditionalComments: boolean;
  evaluationCriteria: EvaluationCriteria[];
  allowEvaluation: boolean;
  responseType?: ResponseType;
  score: {
    criteriaScores: CriteriaScore[];
    score?: number;
  } | null;
  feedback: Feedback | null;
};

export type GetResponsesByQuizIdResponse = GetResponsesByQuizIdItem[];

export const getResponsesByQuizId = async (
  params: GetResponsesByQuizIdRequestParams,
  signal?: AbortSignal,
) =>
  axios
    .get<GetResponsesByQuizIdResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/responses`,
      {
        params: {
          dimension: params.dimension,
          topic: params.topic,
        },
        signal,
      },
    )
    .then((res) => res.data);
